import React, { useState, useEffect, useRef } from "react";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { alphaNumeric, convert, numOnly } from "./utils";
import { Button } from "../../components";
import { getCkyc, setCkycSuccess } from "./details.slice";
import { useDispatch, useSelector } from "react-redux";
import OverlayMessage from "../OverlayMessage/OverlayMessage";
import { useLocation } from "react-router";

const CkycBajaj = ({ onSubmitCKYCBajaj, ...props }) => {
  console.log("children", props);
  const yupValidate = yup.object().shape({
    is_ckyc_no: yup.boolean(),

    pan_no: yup
      .string()
      .nullable()
      .when("is_cky_no", {
        is: (val) => !val,
        then: yup
          .string()
          .nullable()
          .required("Pan no. is required")
          .matches(
            /[a-zA-Z]{3}[PCHFATBLJG]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/,
            "PAN number invalid"
          ),
      }),

    ckyc_no: yup
      .string()
      .nullable()
      .when("is_cky_no", {
        is: (val) => val,
        then: yup
          .string()
          .nullable()
          .required("CKYC No. is required")
          .matches(/^[5-9][0-9]{9}$/, "Must be only digits")
          .min(12, "CKYC No. should be 12 digits")
          .max(12, "CKYC No. should be 12 digits"),
      }),
    ...(showPOI && {
      poi_id: yup.string(),
      aadhar_no: yup
        .string()
        .nullable()
        .when("poi_id", {
          is: (val) => val == 1,
          then: yup
            .string()
            .required("Aadhar No. is required")
            .matches("^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$", "Invalid aadhar no"),
        }),
      voter_id: yup
        .string()
        .nullable()
        .when("poi_id", {
          is: (val) => val == 2,
          then: yup
            .string()
            .required("Voter ID. is required")
            .matches(/^([a-zA-Z]){3}([0-9]){7}?$/),
        }),
      driving_licence: yup
        .string()
        .nullable()
        .when("poi_id", {
          is: (val) => val == 3,
          then: yup.string().required("Driving Licence required"),
        }),
      passport_number: yup
        .string()
        .nullable()
        .when("poi_id", {
          is: (val) => val == 4,
          then: yup
            .string()
            .required("Passport no. required")
            .matches(
              /^[A-Za-z][A-Za-z0-9]\d\s?\d{4}[0-9]$/,
              "Passport number invalid"
            ),
        }),
    }),
    ...(showPOI && {
      addressProof: yup
        .mixed()
        .test("addressProof", "Please Select the file", (value) => value[0])
        .test(
          "addressProof",
          "File is too large",
          (value) => value[0]?.size / 1024 / 1024 <= 10
        )
        .required("Please choose File"),
    }),
  });
  const { ckycFailCount, isCkycSuccess, ckycLoading } = useSelector(
    (state) => state.detailsform
  );
  const {
    handleSubmit,
    register,
    watch,
    control,
    trigger,
    reset,
    errors,
    setValue,
  } = useForm({
    defaultValues: {},
    resolver: !isCkycSuccess ? yupResolver(yupValidate) : null,
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });

  const ckycResult = props?.formDataCkyc?.status;
  console.log("istrigeringHere", errors);
  const [showPOI, setShowPOI] = useState(false);
  const [showCKYC, setShowCKYC] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    if (ckycFailCount === 1) {
      setShowPOI(true);
      setShowCKYC(false);
    }
  }, [ckycFailCount]);
  const ckyc_no = watch("ckyc_no");
  const is_ckyc_no = watch("is_ckyc_no");
  const pan_no = watch("pan_no");
  const poi_id = watch("poi_id");
  const addressProof = watch("addressProof");
  const aadhar_number = watch("aadhar_no");
  const passport = watch("passport_number");
  const voter_id = watch("voter_id");
  const driving_licence = watch("driving_licence");
  const { data } = useSelector((state) => state?.detailsform?.personal);
  const DOB = data?.data[0]?.dob;
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const enquiry_id = query.get("enquiry_id");
  console.log("is_ckyc_no", is_ckyc_no);
  const [uploadStatus, setUploadStatus] = useState(false);
  const poi_map = {
    1: "aadhar_number",
    2: "voter_id",
    3: "driving_licence",
    4: "passport",
  };
  const proofs = {
    aadhar_number,
    passport,
    voter_id,
    driving_licence,
  };

  const onFileUpload = async (file, name) => {
    const b64 = await convert(file);

    dispatch(
      getCkyc({
        ic_id: 1,
        pan_no: "",
        mode: "document",
        company_alias: "bajaj_allianz",
        type: "api",
        docType: poi_map[poi_id],
        documentData: b64,
        docNumber: proofs[poi_map[poi_id]],
        file_name: file?.name,
      })
    );
    setUploadStatus(true);
  };
  return (
    <div style={{ width: "100%" }}>
      <Form onSubmit={handleSubmit(onSubmitCKYCBajaj)}>
        {ckycResult == true || isCkycSuccess ? (
          <>
            <OverlayMessage
              ckycResult={ckycResult}
              isCkycSuccess={isCkycSuccess}
              Review={props?.Review}
            >
              <h3 style={{ textAlign: "center" }}>
                {" "}
                Your KYC is complete, you can proceed.
              </h3>
            </OverlayMessage>
          </>
        ) : (
          <>
            {showCKYC && (
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="">
                  <div className="toggleRadio m-0">
                    <label
                      className="mr-3"
                      style={{
                        color: "#028cc8",
                        letterSpacing: "1px",
                        fontSize: "12px",
                        fontWeight: "normal",
                      }}
                    >
                      Do you have CKYC number?
                    </label>
                    <label className="selectLabel ml-0">No</label>
                    <label className="switch yes-switch">
                      <input
                        name={`is_ckyc_no`}
                        type="checkbox"
                        id={`qstn`}
                        className="min-y"
                        ref={register}
                        defaultChecked
                      />
                      <span className="slider round"></span>
                    </label>

                    <label class="selectLabel">Yes</label>
                  </div>
                </Col>
                {is_ckyc_no && (
                  <div className="p-2">
                    <Form.Group>
                      <Form.Label style={{ fontSize: "14px" }}>
                        CKYC Number
                      </Form.Label>
                      <Controller
                        as={<Form.Control type="text" maxLength="14" />}
                        required
                        name="ckyc_no"
                        control={control}
                        onKeyPress={numOnly}
                      />
                      {errors?.ckyc_no || errors?.ckyc_no ? (
                        <p className="error">
                          {errors?.ckyc_no || errors?.ckyc_no?.message}
                        </p>
                      ) : (
                        ""
                      )}
                    </Form.Group>

                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        trigger("ckyc_no");
                        if (ckyc_no && !errors.ckyc_no) {
                          dispatch(
                            getCkyc({
                              ic_id: 1,
                              ckyc_number: ckyc_no,
                              dob: DOB,
                              mode: "ckyc_number_with_dob",
                              company_alias: "bajaj_allianz",
                              type: "api",
                              section: "cyber",
                              enquiry_id: enquiry_id,
                            })
                          );
                        }
                      }}
                      type="button"
                    >
                      <text
                        style={{
                          fontSize: "15px",
                          padding: "-20px",
                          margin: "-20px -5px -20px -5px",
                          fontWeight: "400",
                        }}
                      >
                        Verify CKYC Number
                      </text>
                    </Button>
                  </div>
                )}
                {!is_ckyc_no && (
                  <div className="p-2">
                    <Form.Group>
                      <Form.Label style={{ fontSize: "14px" }}>
                        PAN Number
                      </Form.Label>
                      <Controller
                        as={<Form.Control type="text" />}
                        required
                        name="pan_no"
                        control={control}
                        maxLength="10"
                        placeholder="PAN No"
                        onInput={(e) =>
                          (e.target.value = ("" + e.target.value).toUpperCase())
                        }
                      />
                      {/* {errors?.pan_no || errors?.pan_no ? (
                  <p className="error">
                    {errors?.pan_no || errors?.pan_no?.message}
                  </p>
                ) : (
                  ""
                )} */}
                    </Form.Group>

                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        trigger("ckyc_no");
                        if (pan_no && !errors.pan_no) {
                          dispatch(
                            getCkyc({
                              ic_id: 1,
                              pan_no: pan_no,
                              dob: DOB,
                              mode: "pan_number_with_dob",
                              company_alias: "bajaj_allianz",
                              type: "api",
                              section: "cyber",
                              enquiry_id: enquiry_id,
                            })
                          );
                        }
                      }}
                      type="button"
                    >
                      <text
                        style={{
                          fontSize: "15px",
                          padding: "-20px",
                          margin: "-20px -5px -20px -5px",
                          fontWeight: "400",
                        }}
                      >
                        Verify PAN Number
                      </text>
                    </Button>
                  </div>
                )}
              </Row>
            )}
            {showPOI && (
              <Row>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="">
                  <div className="py-2 fname mb-2">
                    <Form.Label style={{ fontSize: "14px" }}>
                      Proof of Address
                    </Form.Label>
                    <Controller
                      as={
                        <Form.Control as="select">
                          <option selected value="0">
                            Select Documents
                          </option>
                          <option value="1">Aadhar Card</option>
                          <option value="2">Voter ID</option>
                          <option value="4">Passport</option>
                        </Form.Control>
                      }
                      required
                      name="poi_id"
                      control={control}
                      size="sm"
                    />
                    {poi_id == 1 ? (
                      <>
                        <Form.Control
                          name={`aadhar_no`}
                          ref={register}
                          key={"aadhar_no"}
                          type="tel"
                          placeholder="Aadhar card Number"
                          errors={errors.aadhar_no}
                          size="sm"
                          onInput={numOnly}
                          maxLength="12"
                        />
                        {errors?.aadhar_no || errors?.aadhar_no ? (
                          <p className="error">
                            {errors?.aadhar_no || errors?.aadhar_no?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </>
                    ) : poi_id == 2 ? (
                      <>
                        <Form.Control
                          name={`voter_id`}
                          ref={register}
                          type="tel"
                          key={"voter_id"}
                          placeholder="Voter ID"
                          errors={errors.voter_id}
                          size="sm"
                          onInput={alphaNumeric}
                          maxLength="12"
                        />
                        {errors?.voter_id || errors?.voter_id ? (
                          <p className="error">
                            {errors?.voter_id || errors?.voter_id?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </>
                    ) : poi_id == 3 ? (
                      <>
                        <Form.Control
                          name={`driving_licence`}
                          ref={register}
                          type="tel"
                          placeholder="Driving Licence"
                          errors={errors.driving_licence}
                          size="sm"
                          key={"driving"}
                          onInput={alphaNumeric}
                          maxLength="12"
                        />
                        {errors?.driving_licence || errors?.driving_licence ? (
                          <p className="error">
                            {errors?.driving_licence ||
                              errors?.driving_licence?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </>
                    ) : poi_id == 4 ? (
                      <>
                        <Form.Control
                          errors={errors.passport_number}
                          name="passport_number"
                          placeholder="Passport Number"
                          maxLength="8"
                          key={"passport"}
                          ref={register}
                          size="sm"
                          onInput={(e) =>
                            (e.target.value = (
                              "" + e.target.value
                            ).toUpperCase())
                          }
                        />
                        {errors?.passport_number || errors?.passport_number ? (
                          <p className="error">
                            {errors?.passport_number ||
                              errors?.passport_number?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            {showPOI && (
              <Row>
                <div style={{ marginTop: "20px" }} className="px-3">
                  <h6 className="mobsubhead text-danger">
                    Please upload JPEG, PDF, PNG, TIFF file types only. Size
                    (upto 10MB)
                  </h6>
                  <div style={{ width: "60%" }}>
                    <input
                      // upl
                      type="file"
                      name="addressProof"
                      id="addressProof"
                      accept="image/*,.pdf"
                      ref={register}
                    />
                    {errors?.addressProof || errors?.addressProof ? (
                      <p className="error">
                        {errors?.addressProof || errors?.addressProof?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        trigger("addressProof");
                        if (addressProof[0])
                          onFileUpload(addressProof[0], "address_proof");
                      }}
                      type="button"
                    >
                      <text
                        style={{
                          fontSize: "15px",
                          padding: "-20px",
                          margin: "-20px -5px -20px -5px",
                          fontWeight: "400",
                        }}
                      >
                        Upload Proof of Adress
                      </text>
                    </Button>
                  </div>
                </div>
              </Row>
            )}
          </>
        )}
        {ckycResult == true ||
          (isCkycSuccess && (
            <Row
              style={{
                display: "flex",
                marginTop: "40px",
                justifyContent: "center",
              }}
            >
              <Button
                style={{
                  fontWeight: "400",
                  fontSize: "15px",
                  borderRadius: "5%",
                  height: "35px",
                  paddingTop: "5px",
                }}
                type="submit"
              >
                Submit Proposal Form
              </Button>
            </Row>
          ))}
      </Form>
    </div>
  );
};

export default CkycBajaj;
